import labelGeral from '$/Labels'

const labels = []

labels['exercicioLabel'] = 'Exercício'
labels['mesLabel'] = 'Mês'
labels['administracaoLabel'] = labelGeral.administracao
labels['orgaoLabel'] = 'Órgão'
labels['funcaoLabel'] = 'Função'
labels['subFuncaoLabel'] = 'Subfunção'
labels['despesaLabel'] = 'Natureza da Despesa'
labels['recursosVinculadosLabel'] = 'Recurso'
labels['recursosDestinacaoLabel'] = 'Destinação'
labels['filtrosLabel'] = 'Filtros'

labels['janeiro'] = 'Janeiro'
labels['fevereiro'] = 'Fevereiro'
labels['marco'] = 'Março'
labels['abril'] = 'Abril'
labels['maio'] = 'Maio'
labels['junho'] = 'Junho'
labels['julho'] = 'Julho'
labels['agosto'] = 'Agosto'
labels['setembro'] = 'Setembro'
labels['outubro'] = 'Outubro'
labels['novembro'] = 'Novembro'
labels['dezembro'] = 'Dezembro'

labels['administracao.placeholder'] = 'Busque por ' + labelGeral.administracao
labels['orgao.placeholder'] = 'Busque por órgão'
labels['funcao.placeholder'] = 'Busque por função'
labels['subFuncao.placeholder'] = 'Busque por sub função'
labels['despesa.placeholder'] = 'Busque por natureza da despesa'
labels['recursosVinculados.placeholder'] = 'Busque por recurso'
labels['recursosDestinacao.placeholder'] = 'Busque por destinação'

labels['removerFitlroAplicado'] = 'Remover filtro'
labels['atualizarFiltro'] = 'Atualizar'

labels['criteriosAtualizados'] = ''

labels['nenhumFiltroAplicado'] = 'Nenhum filtro aplicado'

export default labels
